module.exports = __webpack_public_path__ + "static/img/jining3.5736f7f4.jpg";